// Unpoly can't render an Inertia page into its fragments. It gets one when its selectors missed a link, when a
// request is redirected into the Inertia app (e.g. a login form returning to an Inertia page), or as an error page.
// InertiaBoundary::Middleware marks those responses, and they become full page loads of the URL the request ended on.
// A failed form submission can't be repeated as a page load, so it loads the error page by its own route instead.
const ERROR_ROUTES = [404, 410, 422]

function errorRoute(status: number): string {
  return `/${ERROR_ROUTES.includes(status) ? status : 500}`
}

export function registerInertiaPageHandler(): () => void {
  return up.on('up:fragment:loaded', (event) => {
    const { response } = event
    if (!response.header('X-Inertia-Page')) return

    event.preventDefault()
    const failedSubmission = response.method !== 'GET' && response.status >= 400
    up.network.loadPage({ url: failedSubmission ? errorRoute(response.status) : response.url })
  })
}
